import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { userTierPreferencesService } from '../services/userTierPreferencesService'
import type { ModelConfig } from '@modelstack/shared-schema/auth'

export function useUserTierPreferences(enabled: boolean = true) {
  return useQuery({
    queryKey: ['user-tier-preferences'],
    queryFn: () => userTierPreferencesService.get(),
    enabled,
  })
}

export function useUpdateUserTierPreferences() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ modelConfig }: { modelConfig: ModelConfig }) =>
      userTierPreferencesService.update(modelConfig),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user-tier-preferences'] })
      toast.success('Model routing preferences updated')
    },
    onError: (error: Error) => {
      toast.error(`Failed to update preferences: ${error.message}`)
    },
  })
}
